export const userLogin=(model) => {

return $.post('token',model);


}

export const forgotPassword = (userName) => {
  return $.post('Account/ForgotPassword?userName=' + userName)
  // return request.post('/api/Account/ForgotPassword?userName=' + userName)

}



// WEBPACK FOOTER //
// ./src/pages/login/login.service.js